import React from "react";

const TooltipComponent = ({ children, name, position = "bottom" }) => {
    return (
      <div className="tooltip-wrapper">
        {children}
        <div className={`tooltip-text tooltip-${position}`}>{name}</div>
      </div>
    );
  };

export default TooltipComponent;
